import React from 'react';
import SkillsAndPerks from './SkillsAndPerks';

const App = () => {
    return (
        <div className="App">
            <SkillsAndPerks />
        </div>
    );
}

export default App;